import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Menu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      {/* Logo */}
      <Link to="/" className="logo">RED BUTTON</Link>

      {/* Navigation Menu */}
      <nav className="navigation">
        {/* Бургер кнопка */}
        <button 
          className="burger-menu"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Десктопная навигация */}
        <div className="desktop-nav">
          <Link to="/" className="nav-link">Главная</Link>
          <Link to="/setup" className="nav-link">Установка</Link>
          <a className="nav-link"
              onClick={() => {
                  window.location.href = '/#/';
                  setTimeout(() => {
                    document.getElementById('next')?.scrollIntoView({ behavior: 'smooth' });
                  }, 200);
                }}
          >Возможности</a>
          <a className="nav-link" 
             onClick={() => {
                  window.location.href = '/#/';
                  setTimeout(() => {
                    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
                  }, 200);
                }}>Тарифы</a>
          <a  className="nav-link"
              onClick={() => {
                  window.location.href = '/#/';
                  setTimeout(() => {
                    document.getElementById('footer')?.scrollIntoView({ behavior: 'smooth' });
                  }, 200);
                }}
          >Контакты</a>
          <a href="https://my.1button.red" target="_blank" rel="noopener noreferrer" className="nav-link nav-link-login">Войти</a>
        </div>

        {/* Мобильная навигация */}
        <div className={`mobile-nav ${isMenuOpen ? 'mobile-nav-open' : ''}`}>
          <button 
            className="close-menu"
            onClick={() => setIsMenuOpen(false)}
          >
            ×
          </button>
          
          <Link to="/" className="mobile-nav-link">Главная</Link>
          <Link to="/setup" className="mobile-nav-link">Установка</Link>
          <a href="#features" className="mobile-nav-link" onClick={() => setIsMenuOpen(false)}>Возможности</a>
          <a className="mobile-nav-link" 
             onClick={() => {
                  window.location.href = '/#/';
                  setTimeout(() => {
                    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
                  }, 200);
                }}>Тарифы</a>
          <a href="#contact" className="mobile-nav-link" onClick={() => setIsMenuOpen(false)}>Контакты</a>
          <a href="https://my.1button.red" target="_blank" rel="noopener noreferrer" className="mobile-nav-link mobile-nav-link-login" onClick={() => setIsMenuOpen(false)}>Войти</a>
        </div>

        {/* Overlay для закрытия при клике вне меню */}
        {isMenuOpen && (
          <div 
            className="menu-overlay"
            onClick={() => setIsMenuOpen(false)}
          ></div>
        )}
      </nav>
    </>
  );
};

export default Menu;